module.exports = __webpack_public_path__ + "static/img/topbg.9f74d09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/topbg.png
// module id = DW8A
// module chunks = 19